/**
 * Wire contract for the admin reports LIST surface (AUT-116 /
 * PHASE-B-API-5):
 *
 *   - `GET /admin/reports` → `ListAdminReportsResultDto`
 *
 * Centralised in `@carcheck/shared` so the api + admin SPA import the
 * same source of truth — no api↔admin mirror drift.
 *
 * PII discipline (architect lock — AUT-116): the `inspectorName` /
 * `customerName` fields carry REDACTED values (`И. Д••`) when the
 * calling admin lacks the `view_pii` permission. The `piiRevealed` flag
 * tells the SPA which variant it received so it never re-redacts a full
 * value or renders a redacted value as copyable. The server is the sole
 * authority on redaction — `moderate_reports` is the ACCESS gate (admin
 * must hold it to read the surface at all), `view_pii` is the additional
 * REVEAL gate.
 *
 * All `Date` fields are ISO-8601 strings (JSON has no `Date`); consumers
 * convert at the render boundary via `new Date(dto.submittedAt)`.
 */
/**
 * Admin-facing report FSM status — the FULL 5-state internal lifecycle.
 * Mirror of Prisma `ReportStatus` (`report-status.ts`); kept here so the
 * SPA avoids `@prisma/client`.
 *
 * Single source of truth for the api's filter Zod schema too — the api
 * imports `ADMIN_REPORT_STATUSES` rather than hand-typing the values.
 */
export const ADMIN_REPORT_STATUSES = [
    'in_progress',
    'submitted',
    'approved',
    'rejected',
    'revision_requested',
];
//# sourceMappingURL=admin-report-list.js.map